var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"allPage"},[_c('newHeader'),_c('div',{staticClass:"Box scrollbar"},[_c('router-view',{staticClass:"content"}),_c('Footer',{staticClass:"footer"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }